

























































































































// vue
import Vue, { PropOptions } from 'vue';
import NOC from '@/class/common/const';

import API from '@/api/common';
import { IAPP } from '@/class/models/views/app';
import * as models from '@/class/models/views/account';
import SideMenu from '@/components/util/SideMenu.vue';
import DialogBase from '@/components/util/DialogBase.vue';

export default Vue.extend({
  name: 'ClientTools',
  components: {
    SideMenu,
    DialogBase,
  },
  props: {
    appData: Object as PropOptions<IAPP>,
  },
  data() {
    return {
      onload: false,
      accountData: {} as models.IAccount,
      dummy: 'password',
      uninstallPassword: '',
      openPassword: false,
      showMobileId: false,
    };
  },
  computed: {
    USE_QUIT(): boolean {
      return (this.appData.contractStatus === NOC.CONTRACT.CONFIRM
        || this.appData.contractStatus === NOC.CONTRACT.STOP
        || this.appData.contractStatus === NOC.CONTRACT.QUIT);
    },
  },
  // 画面表示時処理
  async mounted() {

    // データ取得
    const api = new API();
    const res = await api.get<models.IAccount>('account');

    if (res.result) {
      this.accountData = res.data;
      this.uninstallPassword = this.accountData.uninstallPass.toString();
    } else {
      this.$emit('change', NOC.APP.MODE.LOGIN);
    }
    this.$emit('pushPath', this.$route.path);

    // 読み込み完了
    this.onload = true;
  },
  methods: {
    onClickDownload64() {
      this.download(NOC.OS.WINDOWS, '64');
    },
    onClickDownload32() {
      this.download(NOC.OS.WINDOWS, '32');
    },
    onClickDownloadMac() {
      this.download(NOC.OS.MAC, '');
    },
    onClickDownloadAndroid() {
      this.download(NOC.OS.ANDROID, '');
    },
    async download(OS: string, bit: string) {
      try {
        const response = await new API().get<any>('download/client', { OS, bit });
        if (response.result === NOC.API.RESULUT.FAIL) {
          this.$emit('info', 'ダウンロードに失敗しました。');
        }
      } catch (e) {
        this.$emit('info', '通信できませんでした。');
      }
    },
    uninstallType() {
      if (this.openPassword) {
        return 'text';
      } else {
        return 'password';
      }
    },
    async getPatch(bit: string) {
      const api = new API();
      const res = await api.get<any>(`download/update/${bit}`);
      if (res.result) {
        // this.disp = NOC.APP.MODE.AUTH;
        // this.disp = NOC.APP.MODE.LOGIN;
        // this.changeMode(this.disp);
      } else {
        this.$emit('info', '通信できませんでした。');
      }
    },
  },
});
